export const KEYCLOAK_AUTH_INIT = "KEYCLOAK_AUTH_INIT"


export const authInit = (data) => ({
    type:KEYCLOAK_AUTH_INIT,
    payload: data
})